import { Box, Typography } from "@mui/material";
import CustomButton from "../../../components/CustomButton";
import { API_CONFIG } from "./constants";
import { ApiKeyRowProps } from "./types";
import { isUSA } from "../../../constants/env";

export const ApiKeyRow: React.FC<ApiKeyRowProps> = ({
  apiKey,
  websiteData,
  isWebsiteLoading,
  onModalOpen,
  statusSuccess,
  getStringStatus,
  onlyUsaVisible,
  t,
  classes,
}) => {
  const config = API_CONFIG[apiKey.type];
  const isKeyAdded = !!websiteData?.[config.apiKeyField];
  const displayName =
    apiKey.type === "spolehliveRecenze" ? t("spolehliveRecenze") : apiKey.name;

  // Check visibility based on region
  if (onlyUsaVisible !== undefined) {
    if (onlyUsaVisible && !isUSA) {
      return null; // Service only for USA, but user is not in USA
    }
    if (!onlyUsaVisible && isUSA) {
      return null; // Service not for USA, but user is in USA
    }
  }
  
  return (
    <Box className={classes.apiKeyRow}>
      <Typography style={{ marginLeft: 35 }}>{displayName}</Typography>
      <Box style={{ flex: 1 }} />

      {isKeyAdded ? (
        <Box onClick={() => onModalOpen(apiKey.type)}>{statusSuccess}</Box>
      ) : (
        <CustomButton
          size='medium'
          title={getStringStatus?.(apiKey.type, websiteData) ?? "Přidat"}
          onClick={() => onModalOpen(apiKey.type)}
          style={{ marginRight: 24, width: 90 }}
          isLoading={isWebsiteLoading}
        />
      )}
    </Box>
  );
};
